import { getLocale } from "../runtime";

const da_whichvariant = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Hvilken variant ønsker du?`
};

const en_whichvariant = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Which variant would you like?`
};

const es_whichvariant = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `¿Qué variante quieres?`
};

const fi_whichvariant = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Minkä vaihtoehdon haluat?`
};

const nb_whichvariant = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Hvilken variant vil du ha?`
};

const sv_whichvariant = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Vilken variant vill du ha?`
};

const whichvariant = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_whichvariant(inputs)
	if (locale === "en") return en_whichvariant(inputs)
	if (locale === "es") return es_whichvariant(inputs)
	if (locale === "fi") return fi_whichvariant(inputs)
	if (locale === "nb") return nb_whichvariant(inputs)
	if (locale === "sv") return sv_whichvariant(inputs)
	return "whichVariant";
};

export { whichvariant as "whichVariant" };